// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T45W","placeholdersHeader":"styles_placeholdersHeader__3A6BN","editorStyle":"styles_editorStyle__3l_DS","placeholdersBox":"styles_placeholdersBox__2OwAb"};